import type {Command, GlobalAttributes} from '@tiptap/core';
import {Extension} from '@tiptap/core';
import {MarkType} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/tiptap/TipTapEditor";
import {erIkkeTomStreng} from "felles-ng2/støttefunksjoner/strenger";

/** Tiptap utvidelse som legger til attributtet 'tekstbakgrunnsfarge' for bruk på noder som støtter 'textStyle' mark */
export const TekstBakgrunnsfarge = Extension.create({

    name: 'TekstBakgrunnsfarge',

    addGlobalAttributes(): GlobalAttributes {
        return [{
            types: tillatteMarktyper(),
            attributes: {
                tekstbakgrunnsfarge: {
                    default: null,
                    renderHTML: attributter => tekstbakgrunnsfargeSomHtmlStyleAttributt(attributter),
                    parseHTML: element => htmlBackgroundColorStyleSomBakgrunnsfargeAttributt(element),
                    keepOnSplit: true
                }
            }
        }]
    },

    addCommands(): TekstBakgrunnKommandoer<Command> {
        return {
            setTekstBakgrunnsfarge: (tekstbakgrunnsfarge) => ({chain}) =>
              chain().setMark(MarkType.TextStyle, {tekstbakgrunnsfarge: tekstbakgrunnsfarge}).run(),

            fjernTekstBakgrunnsfarge: () => ({chain}) =>
              chain()
                .setMark(MarkType.TextStyle, {tekstbakgrunnsfarge: null})
                .removeEmptyTextStyle()
                .run(),

        };
    },
});

function tillatteMarktyper() {
    return [MarkType.TextStyle];
}

/** Serialiserer 'bakgrunnsfarge' attributtet til html css style.background attributt */
export function tekstbakgrunnsfargeSomHtmlStyleAttributt(attributter: Record<string, any>): Record<string, any> {
    return erIkkeTomStreng(attributter.tekstbakgrunnsfarge) ? {style: `background-color: ${attributter.tekstbakgrunnsfarge}`} : {};
}

/** Deserialiserer css style.backgroundColor property satt på angitt element til bakgrunnsfarge */
function htmlBackgroundColorStyleSomBakgrunnsfargeAttributt(element: HTMLElement): string {
    return element.style.backgroundColor;
    //@todo var def med .replaceAll(/['"]+/g, ''),; - hvorfor?? for å fjerne " ??må sjekkes - gjøres også tpå tabellcellebkg
}


// typedefinisjoner

interface TekstBakgrunnKommandoer<ReturnType> {
    /** Setter bakgrunnsfarge på tekst */
    setTekstBakgrunnsfarge: (bakgrunnsfarge: string) => ReturnType;

    /** Fjerner eventuell bakgrunnsfarge på tekst */
    fjernTekstBakgrunnsfarge: () => ReturnType;
}

//for at kommandoene skal dukke opp i editor ts typen
declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        tekstBakgrunnsfarge: TekstBakgrunnKommandoer<ReturnType>;
    }
}
